// extracted by mini-css-extract-plugin
export default {"formTextareaBox":"index_formTextareaBox_sH8rp","formTextarea":"index_formTextarea_tzIib","formTextareaWord":"index_formTextareaWord_wQf60","redSize":"index_redSize_5Hcnw"};